
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ReturnsManagementDialog extends _Ext.TransDialog<ECommOrderRow, any> {

        protected getFormKey() { return ECommOrderForm.formKey; }
        protected getIdProperty() { return ECommOrderRow.idProperty; }
        protected getLocalTextPrefix() { return ECommOrderRow.localTextPrefix; }
        protected getNameProperty() { return ECommOrderRow.nameProperty; }
        protected getService() { return ECommOrderService.baseUrl; }
        protected getDeletePermission() { return ECommOrderRow.deletePermission; }
        protected getInsertPermission() { return ECommOrderRow.insertPermission; }
        protected getUpdatePermission() { return ECommOrderRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new ECommOrderForm(this.idPrefix);
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ECommExchangeRate: number;

        statement: string;
        contractTotals: string;
        TaxArray: any[];

        constructor() {
            super();
            //Make grid full width
            this.set_dialogTitle("Return Order");
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            q.initItemEditor(this, this.form.ReceiptDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.ReceiptAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.SetSix12Column(this.form.ReceiptDetails);



            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFourColumn(this.form.BillingAddress);
            q.SetCategoryTwoColumn(this.form.VoucherTypeId);
            q.SetCategoryFourColumn(this.form.ShippingAddress);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);

            q.hideEditorCategoryLabel(this.form.TransDate.element);
            q.hideEditorCategoryLabel(this.form.ProductItemImage.element);
            q.hideEditorCategoryLabel(this.form.VoucherTypeId.element);
            q.hideEditorCategoryLabel(this.form.BillNo.element);
            q.hideEditorCategoryLabel(this.form.ItemDetails.element);
            q.hideEditorCategoryLabel(this.form.ReceiptDetails.element);
            q.hideEditorCategoryLabel(this.form.Pieces.element);
            q.hideEditorCategoryLabel(this.form.NetAmount.element);
            q.hideEditorCategoryLabel(this.form.Remark.element);

            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = parseInt(this.form.POSCustomerId.value);
                if (cid > 0) {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    var firstname = CustomerDetails.FirstName == undefined ? "" : CustomerDetails.FirstName;
                    var lastname = CustomerDetails.LastName == undefined ? "" : CustomerDetails.LastName;
                    this.form.CustomerName.value = firstname + " " + lastname;
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                    this.form.GrossAmount.value = 0;
                }
            });
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });

             
            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            var Receipts: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);

            });

            (this.form.ReceiptDetails.view as any).onRowCountChanged.subscribe(() => {
                this.calculateReceiptTotal();
            });


            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();

        }

        public CalculateAmountandTax(Items: any, TotalItems: number) {
            if (!this.isViewMode()) {

                var codearray = [];
                var amtarray = [];
                var TaxDetail = [];
                var ItemTotal = 0;
                var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var nwt = 0; var wt = 0;

                //Items.forEach(function (x)
                for (var x of Items) {
                    ntamt += x.NetAmount || 0;
                    gramt += x.GrossAmount || 0;
                    disc += x.Discount || 0;
                    pcs += x.Pieces || 0;
                    wt += x.Weight || 0;
                    nwt += x.NetWeight || 0;

                    if (x.HSN != null || x.HSN != "NA") {
                        var temp = false;
                        for (let i = 0; i < codearray.length; i++) {
                            if (codearray[i] == x.HSN) {
                                amtarray[i] += x.GrossAmount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            codearray.push(x.HSN);
                            amtarray.push(x.GrossAmount);
                        }
                    }
                    ItemTotal++;
                };

                this.form.NetAmount.value = gramt;
                this.form.Discount.value = disc;

                var TaxAmount = 0;

                var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

                if (ItemTotal == TotalItems && TaxApplicable) {

                    //this.form.TaxAmount.value = TaxAmount;
                    this.form.GrossAmount.value = gramt + TaxAmount;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                else {
                    this.form.GrossAmount.value = gramt;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }

                this.form.ItemDetails.render;
            }
        }
        public calculateReceiptTotal() {
            var Receipts = this.form.ReceiptDetails.getItems();
            var totalamount = 0;
            for (var i = 0; i < Receipts.length; i++) {
                totalamount += Receipts[i].Amount;

            }
            this.form.ReceiptAmount.value = totalamount;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.ReceiptDetails.set_readOnly(true);
            this.form.ItemDetails.set_readOnly(true);
            var address = this.entity.AddressDetails;
            for (var i = 0; i < address.length; i++) {
                if (address[i].Type == 47) {

                    this.form.ShippingAddress.value = address[i].Address1;
                    this.form.ShippingCity.value = address[i].City.toString();
                    this.form.ShippingCityName.value = address[i].City.toString();
                    this.form.ShippingState.value = address[i].State != null ? address[i].State.toString() : "0";
                    this.form.ShippingStateName.value = address[i].StateName;
                    this.form.ShippingCountry.value = address[i].Country.toString();
                    this.form.ShippingCountryName.value = address[i].CountryName.toString();
                    this.form.ShippingPincode.value = address[i].Pincode.toString();
                } else if (address[i].Type == 48) {
                    this.form.BillingAddress.value = address[i].Address1;

                    this.form.BillingCity.value = address[i].City;
                    this.form.BillingCityName.value = address[i].City.toString();
                    this.form.BillingState.value = address[i].State != null ? address[i].State : 0;
                    this.form.BillingStateName.value = address[i].StateName;
                    this.form.BillingCountry.value = address[i].Country;
                    this.form.BillingCountryName.value = address[i].CountryName.toString();
                    this.form.BillingPin.value = address[i].Pincode.toString();
                }
            }
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            btns = btns.filter(x => x.cssClass == "");

            ////Export PDF Button
            btns.push({
                title: 'Accept Return',
                icon: 'icon-save',
                onClick: () => {
                    var dialog = new Common.AcceptReturnDialog();
                    dialog.element.on('dialogclose', () => {
                        if (dialog.checksuccess) {
                            var _entity: ECommOrderRow = {
                                TransId: this.entity.TransId,
                                ReasonId: parseInt(dialog.form.ReasonId.value),
                                Remark: dialog.form.Remark.value,
                                OrderStatusId: 13
                            }
                            ECommOrderService.Update({ Entity: _entity, EntityId: this.entity.TransId }, response => { }, { async: false });
                            this.dialogClose();
                        }
                    });
                    dialog.dialogOpen();
                }
            });
            btns.push({
                title: 'Cancel Return',
                icon: 'fa-times',
                onClick: () => {
                    var dialog = new Common.CancelOrderDialog();
                    dialog.element.on('dialogclose', () => {
                        if (dialog.checksuccess) {
                            var _entity: ECommOrderRow = {
                                TransId: this.entity.TransId,
                                ReasonId: parseInt(dialog.form.ReasonId.value),
                                Remark: dialog.form.Remark.value,
                                OrderStatusId: 8
                            }
                            ECommOrderService.Update({ Entity: _entity, EntityId: this.entity.TransId }, response => { }, { async: false });
                            this.dialogClose();
                        }
                    });
                    dialog.dialogOpen();
                }
            });


            return btns;
        } 
    }
}